
document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.products-carousel', {
        perPage: 4,
        gap: 30,
        breakpoints: {
            640: {
                perPage: 2,
            },
      }
    });
    splide.mount();
});